import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { GlobalLoaderComponent } from "./core/components/global-loader/global-loader.component";
import { SnackbarNotificationModule } from "./core/modules/snackbar-notification/snackbar-notification.module";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, GlobalLoaderComponent, SnackbarNotificationModule],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent {}
